// src/utils/firebase/uploadMetadata.ts
import { saveRegionalUserProfile } from "../backend/pdxBackendClient";

/**
 * Persist a form-answers object through the protected regional backend.
 *
 * The backend service now owns user profile/account context. This helper keeps
 * the legacy name so existing form flows can cut over without broad call-site
 * churn.
 *
 * @param {string} uid          – Firebase Auth UID
 * @param {object} answers      – Key⇢value map of the form answers
 * @returns {Promise<string>}   – Compatibility success marker
 */
export async function uploadMetadata(uid, answers) {
  if (!uid) throw new Error("uploadMetadata: uid missing");
  if (!answers || typeof answers !== "object" || Array.isArray(answers))
    throw new Error("uploadMetadata: answers must be an object");

  await saveRegionalUserProfile(answers);

  return "regional-backend-user-context";
}
